// Exports
export default {
	"pulse": "pulse_2gmZj",
	"ParticipantIcon": "ParticipantIcon_j7Luc",
	"Placeholder_abbreviationText": "Placeholder_abbreviationText_sWviX",
	"Placeholder_image": "Placeholder_image_KUyHl",
	"Placeholder_small": "Placeholder_small_QePko",
	"Participant_PlaceholderSvg": "Participant_PlaceholderSvg_HVKYN",
	"Participant_PlaceholderSvg_Visible": "Participant_PlaceholderSvg_Visible_BIL-f",
	"callIconContainer": "callIconContainer_mPBb+",
	"callIcon": "callIcon_T8jOF"
};
